import { getCurrencyMeta, getDefaultCurrencyForCountry } from './currency';
import { getPlatformFeeMinor } from './fees';

function formatMinorAmount(minor, currency) {
  const { symbol, decimals } = getCurrencyMeta(currency);
  const scale = Math.pow(10, decimals);
  const raw = Number(minor || 0) / scale;
  const amount = decimals > 0 ? raw.toFixed(decimals).replace(/\.00$/, '') : String(Math.round(raw));
  return symbol ? `${symbol}${amount}` : `${amount} ${currency}`;
}

export function getPlatformFeeExample(currency) {
  const code = String(currency || 'GBP').toUpperCase();
  const minor = getPlatformFeeMinor({ currency: code });
  return formatMinorAmount(minor, code);
}

export function getPlatformFeeExamplesLabel(currencies = ['GBP', 'USD', 'EUR']) {
  return currencies.map((code) => getPlatformFeeExample(code)).join(' / ');
}

function regionFromLocale(locale) {
  const normalized = String(locale || '').replace('_', '-');
  const match = normalized.match(/-([A-Za-z]{2})\b/);
  return match ? match[1].toUpperCase() : null;
}

export function detectBrowserCurrency(fallback = 'GBP') {
  if (typeof window === 'undefined') return fallback;

  const locales = [
    ...(Array.isArray(window.navigator?.languages) ? window.navigator.languages : []),
    window.navigator?.language,
    Intl.DateTimeFormat().resolvedOptions().locale,
  ].filter(Boolean);

  for (const locale of locales) {
    const region = regionFromLocale(locale);
    if (!region) continue;
    const currency = getDefaultCurrencyForCountry(region, null);
    if (currency) return currency;
  }

  return fallback;
}

export function getLocalPlatformFee(fallback = 'GBP') {
  const currency = detectBrowserCurrency(fallback);
  return {
    currency,
    feeLabel: getPlatformFeeExample(currency),
  };
}
